import { useState, useContext, useEffect } from 'react'
import TransportContext from '../../../Context/transport/TransportProvider';


const ResultSearch_Model = () => {

  const [menuHamburger, setMenuHamburger] = useState(false)
  const [buscadorMenu, setBuscadorMenu] = useState(false)
  const [filtersMenu, setFiltersMenu] = useState(false)
  const [passengerFilter, setPassengerFilter] = useState(7)
  const [filtrado, setFiltrado] = useState([0])
  const [activeFilterP, setActiveFilterP] = useState(false)
  const [activeFilterPrice, setActiveFilterPrice] = useState(false)
  const { resultados } = useContext(TransportContext)

  const [firstRange, setFirstRange] = useState(0)
  const [secondRange, setSecondRange] = useState(0)
  const [errorFilter, setErrorFilter] = useState('')
  
  const menuHambur = (type) => {
    setMenuHamburger(!menuHamburger)
    type ? setFiltersMenu(!filtersMenu) : setBuscadorMenu(!buscadorMenu)
  }

 
const resetFilter = ()=>{
  setFiltrado([0])
}

  useEffect(() => {
    if(resultados[0] !== 0){
      const filtrados = resultados.filter(item => {
      return parseInt(item.passengerCapacity.split('-')[1]) >= passengerFilter
    })
    
    setFiltrado(filtrados)
    }
    
  }, [activeFilterP])

  useEffect(() => {
    if(firstRange || secondRange === 0){
      setErrorFilter('Es necesario llenar los 2 campos')
    }else{
      if(resultados[0] !== 0){
      setErrorFilter('')
      const filtrados = resultados.filter(item => {
      return item.totalPriceUSD >= firstRange && item.totalPriceUSD <= secondRange
    })
  
    setFiltrado(filtrados)
    }
    }
    
  }, [activeFilterPrice])
  
  


  return {
    menuHambur,
    menuHamburger,
    buscadorMenu,
    filtersMenu,
    passengerFilter,
    setPassengerFilter,
    filtrado,
    activeFilterP,
    setActiveFilterP,
    resetFilter,
    setActiveFilterPrice,
    activeFilterPrice,
    setFirstRange,
    setSecondRange,
    errorFilter
  }
}

export default ResultSearch_Model